import React from "react";

import { selectSelectedRange, selectSelectedStore } from "modules/customer/tools/product/productSlice";
import { useAppSelector } from "store";

const Subtitle: React.FC = () => {
    const selectedRange = useAppSelector(selectSelectedRange);
    const selectedStore = useAppSelector(selectSelectedStore);
    return (
        <>
            See when people visit the {selectedStore?.name} store and how long they stay.
            Spot busy and quiet times to check whether {selectedRange?.name} matches the flow of footfall across the week.
        </>
    );
};

export default Subtitle;
